import I18n from 'I18n';
import CloseIcon from 'conversations-visitor-experience-components/visitor-widget/CloseIcon';
import { isInSDK } from 'conversations-visitor-message-history/utils/isInSDK';
import styled from 'styled-components';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import { adjustLuminance } from 'visitor-ui-component-library/utils/adjustLuminance';
import { getWindowLocation } from '../../query-params/getWindowLocation';
import { postSdkCloseButtonClickEvent } from '../actions/postSdkCloseButtonClickEvent';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledIconButton = styled(VizExIconButton).withConfig({
  displayName: "CloseButton__StyledIconButton",
  componentId: "ty3wux-0"
})(["height:24px;width:24px;border-radius:20px;background-color:", ";border:1px solid ", ";&:active:enabled{background-color:", ";border-color:", ";}margin-left:12px;"], ({
  backgroundColor
}) => backgroundColor, ({
  backgroundColor
}) => backgroundColor, ({
  backgroundColor
}) => adjustLuminance(backgroundColor, -10), ({
  backgroundColor
}) => adjustLuminance(backgroundColor, -10));
const CloseButton = (iconColor, backgroundColor) => {
  let showCloseButton = false;
  const hostingUrl = getWindowLocation().paramValue('url');
  if (isInSDK() && hostingUrl) {
    const hostingParams = new URL(hostingUrl).searchParams;
    if (hostingParams.get('showCloseButton') === 'true') {
      showCloseButton = true;
    }
  }
  return showCloseButton ? /*#__PURE__*/_jsx(StyledIconButton, {
    "aria-label": I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.sdkClickToCloseWidget'),
    backgroundColor: backgroundColor,
    onClick: postSdkCloseButtonClickEvent,
    shape: "circle",
    children: /*#__PURE__*/_jsx(VizExIcon, {
      icon: /*#__PURE__*/_jsx(CloseIcon, {
        height: 12,
        width: 12,
        color: iconColor
      })
    })
  }) : undefined;
};
CloseButton.displayName = 'CloseButton';
export default CloseButton;